import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as userActions from '../actions/userActions';
import * as versionActions from '../actions/versionActions';
import InfoMessage from './ui/messages/InfoMessage';
import ErrorMessage from './ui/messages/ErrorMessage';
import VersionUpdatedMessage from './ui/messages/VersionUpdatedMessage';

class GlobalSubscriptions extends Component {
    constructor(props) {
        super(props);
        this.currentVersion = this.props.version;
    }

    shouldComponentUpdate(props) {
        this.versionChanged =
            this.currentVersion !== null &&
            this.currentVersion !== props.version;
        this.currentVersion = props.version;

        return true;
    }

    reloadPage() {
        window.location.reload(true);
    }

    render() {
        if (this.versionChanged) {
            console.log(
                'Version changed from ' +
                    this.currentVersion +
                    ' to ' +
                    this.props.version
            ); // We don't log to appInsights because this is per user, log to console for informational purposes.
            return <VersionUpdatedMessage version={this.currentVersion} />;
        } else {
            if (this.props.hasDisconnected) {
                return (
                    <ErrorMessage>
                        Live Updates: Connection Lost. You are not currently
                        able to receive live updates from your colleagues
                    </ErrorMessage>
                );
            } else if (this.props.hasReconnected) {
                return (
                    <InfoMessage>
                        Live Updates: Connection Restored. To ensure your orders
                        and fixtures are up to date please refresh your browser
                        by clicking{' '}
                        <span className="linkButton" onClick={this.reloadPage}>
                            here
                        </span>
                    </InfoMessage>
                );
            }
        }
        return null;
    }
}

const mapStateToProps = (state) => {
    return {
        hasDisconnected: state.status.hasSocketDisconnected,
        hasReconnected: state.status.hasSocketReconnected,
        version: state.version,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(
            { ...userActions, ...versionActions },
            dispatch
        ),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GlobalSubscriptions);
